import React, { useState, useEffect } from "react";

const Mission = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Run once to ensure it's accurate even after initial render
    handleResize();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isMobile) {
    return (
      <div>
        <div></div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">Our Mission</div>
      </div>
      <div className="page-body-wrapper">
        <div className="mission-page-body-text-wrapper">
          <div className="mission-page-body-title">
            <div className="mission-page-body-text"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
